/**
 * Who may archive and restore: whoever may edit it (ADR 032). The server
 * checks the same; this only decides which buttons show.
 */

import { useCurrentUser } from "@/features/auth/hooks";
import { useProject } from "@/features/projects/hooks";
import type { ArchiveKind } from "./kinds";

/** `may(row)` for one kind; experiments, queues and scores also go by creator. */
export function useMayArchive(kind: ArchiveKind) {
  const { can } = useProject();
  const me = useCurrentUser().data?.email.toLowerCase() ?? "";
  const mine = (row?: { created_by?: string | null }) => !!me && row?.created_by?.toLowerCase() === me;
  return (row?: { created_by?: string | null }) => {
    switch (kind) {
      case "dataset":
        return can("datasets:write");
      case "evaluator":
        return can("evaluators:write");
      case "experiment":
        return can("experiments:write") && (can("experiments:delete") || mine(row));
      case "queue":
      case "scoreConfig":
        return can("annotations:write") && (can("annotations:manage") || mine(row));
    }
  };
}
